import { Model } from '@arra/core';
import { useQuery } from 'react-query';
import { authenticatedFetch } from '../../authentication/authenticatedFetch';

const getModels = async (filter?: any): Promise<Model[]> => {
  const response = await authenticatedFetch(
    `${process.env.REACT_APP_API_URL}/models?${new URLSearchParams(
      filter,
    ).toString()}`,
  );
  return await response.json();
};

const useModels = (filter?: Record<string, any>) => {
  const modelsQuery = useQuery(
    ['models', filter ?? {}],
    () => getModels(filter),
    { useErrorBoundary: true }
  );
  return {
    models: modelsQuery.data,
    loading: modelsQuery.isLoading,
  };
};

export default useModels;
